import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button, Label, Header } from 'semantic-ui-react';
import TextareaAutosize from "react-textarea-autosize";
import { ISiteVodafone } from '../../../app/models/sitevodafone';
import SiteVodafoneStore from '../../../app/stores/sitevodafoneStore';
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';

interface DetailParams {
  id: '',
}

const SiteVodafoneEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history
}) => {
  const sitevodafoneStore = useContext(SiteVodafoneStore);
  const {
    editSiteVodafone,
    submitting,
    loadSiteVodafone,
    clearSiteVodafone,
    sitevodafone: initialFormState,
    loadingInitial
  } = sitevodafoneStore;

  const [sitevodafone, setSiteVodafone] = useState<ISiteVodafone>({
    id: '',
    createdAt: '',
    updatedAt: '',
    siteID_c: '',
    siteName: '',
    direct_Access: '',
    businessHoursSiteAccess: '',
    afterHoursSiteAccess: '',
    businessHoursEmergencySiteAccess: '',
    afterHoursEmergencySiteAccess: '',
    siteType: '',
    fopsData: '',
    key_DirectAccess: '',
    comments: '',
    keyLocationAddress: '',
    keySpecificDetails: '',
    oH_SDetails: '',
    siteHazards: '',
    siteInductionRequired: '',
    siteInductionContactName: '',
    siteInductionContactNumber: '',
    siteInductionContactEmail: '',
    siteInductionDetails: '',
    siteInductionOnlineTraining: '',
    siteInductionOnlineTrainingURL: '',
    siteInductionValidityPeriod: '',
    structureType: '',
    specialDetails: '',
    directions: '',
    address: '',
    addressAdditional: '',
    city: '',
    stateOrProvince: '',
    postalCode: '',
    siteID_c2: '',
    latitude: '',
    longitude: '',
    remark: ''
  });



  useEffect(() => {
    loadSiteVodafone(match.params.id).then(
      () => initialFormState && setSiteVodafone(initialFormState)
    );

    return () => {
      clearSiteVodafone()
    }
  }, []);


  const handleSubmit = () => {
    editSiteVodafone(sitevodafone).then(() => history.push(`/projectmanagement/sitevodafone`));
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setSiteVodafone({ ...sitevodafone, [name]: value });
  };


  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Input
          label='Site Name'
          onChange={handleInputChange}
          name='siteName'
          readOnly
          placeholder='Site Name'
          value={sitevodafone.siteName}
        />
        <Form.Input
          label='Direct Access'
          onChange={handleInputChange}
          name='direct_Access'
          placeholder='Direct Access'
          value={sitevodafone.direct_Access}
        />
        <Form.Field
          label='Business Hours Site Access'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='businessHoursSiteAccess'
          placeholder='Business Hours Site Access'
          value={sitevodafone.businessHoursSiteAccess}
        />
        <Form.Field
          label='After Hours Site Access'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='afterHoursSiteAccess'
          placeholder='After Hours Site Access'
          value={sitevodafone.afterHoursSiteAccess}
        />
        <Form.Field
          label='Business Hours Emergency Site Access'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='businessHoursEmergencySiteAccess'
          placeholder='Business Hours Emergency Site Access'
          value={sitevodafone.businessHoursEmergencySiteAccess}
        />
        <Form.Field
          label='After Hours Emergency Site Access'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='afterHoursEmergencySiteAccess'
          placeholder='After Hours Emergency Site Access'
          value={sitevodafone.afterHoursEmergencySiteAccess}
        />
        <Form.Field
          label='Site Type'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteType'
          placeholder='Site Type'
          value={sitevodafone.siteType}
        />
        <Form.Field
          label='FOPS Data'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='fopsData'
          placeholder='FOPS Data'
          value={sitevodafone.fopsData}
        />
        <Form.Field
          label='Key Direct Access'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='key_DirectAccess'
          placeholder='Key Direct Access'
          value={sitevodafone.key_DirectAccess}
        />
        <Form.Field
          label='Comments'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='comments'
          placeholder='Comments'
          value={sitevodafone.comments}
        />
        <Form.Field
          label='Key Location Address'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='keyLocationAddress'
          placeholder='Key Location Address'
          value={sitevodafone.keyLocationAddress}
        />
        <Form.Field
          label='Key Specific Details'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='keySpecificDetails'
          placeholder='Key Specific Details'
          value={sitevodafone.keySpecificDetails}
        />
        <Form.Field
          label='OH_S Details'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='oH_SDetails'
          placeholder='OH_S Details'
          value={sitevodafone.oH_SDetails}
        />
        <Form.Field
          label='Site Hazards'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteHazards'
          placeholder='Site Hazards'
          value={sitevodafone.siteHazards}
        />
        <Form.Field
          label='Site Induction Required'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionRequired'
          placeholder='Site Induction Required'
          value={sitevodafone.siteInductionRequired}
        />
        <Form.Field
          label='Site Induction Contact Name'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionContactName'
          placeholder='Site Induction Contact Name'
          value={sitevodafone.siteInductionContactName}
        />
        <Form.Field
          label='Site Induction Contact Number'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionContactNumber'
          placeholder='Site Induction Contact Number'
          value={sitevodafone.siteInductionContactNumber}
        />
        <Form.Field
          label='Site Induction Contact Email'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionContactEmail'
          placeholder='Site Induction Contact Email'
          value={sitevodafone.siteInductionContactEmail}
        />
        <Form.Field
          label='Site Induction Details'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionDetails'
          placeholder='Site Induction Details'
          value={sitevodafone.siteInductionDetails}
        />
        <Form.Field
          label='Site Induction Online Training'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionOnlineTraining'
          placeholder='Site Induction Online Training'
          value={sitevodafone.siteInductionOnlineTraining}
        />
        <Form.Field
          label='Site Induction Online Training URL'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionOnlineTrainingURL'
          placeholder='Site Induction Online Training URL'
          value={sitevodafone.siteInductionOnlineTrainingURL}
        />
        <Form.Field
          label='Site Induction Validity Period'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='siteInductionValidityPeriod'
          placeholder='Site Induction Validity Period'
          value={sitevodafone.siteInductionValidityPeriod}
        />
        <Form.Field
          label='Structure Type'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='structureType'
          placeholder='Structure Type'
          value={sitevodafone.structureType}
        />
        <Form.Field
          label='Special Details'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='specialDetails'
          placeholder='Special Details'
          value={sitevodafone.specialDetails}
        />
        <Form.Field
          label='Directions'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='directions'
          placeholder='Directions'
          value={sitevodafone.directions}
        />
        <Form.Field
          label='Address'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='address'
          placeholder='Address'
          value={sitevodafone.address}
        />
        <Form.Field
          label='Address Additional Info'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='addressAdditional'
          placeholder='Address Additional Info'
          value={sitevodafone.addressAdditional}
        />
        <Form.Input
          label='City'
          onChange={handleInputChange}
          name='city'
          placeholder='City'
          value={sitevodafone.city}
        />
        <Form.Input
          label='State Or Province'
          onChange={handleInputChange}
          name='stateOrProvince'
          placeholder='State Or Province'
          value={sitevodafone.stateOrProvince}
        />
        <Form.Input
          label='Postal Code'
          onChange={handleInputChange}
          name='postalCode'
          placeholder='Postal Code'
          value={sitevodafone.postalCode}
        />
        <Form.Input
          label='Site ID 2'
          onChange={handleInputChange}
          name='siteID_c2'
          placeholder='Site ID 2'
          value={sitevodafone.siteID_c2}
        />
        <Form.Input
          label='Latitude'
          onChange={handleInputChange}
          name='latitude'
          placeholder='Latitude'
          value={sitevodafone.latitude}
        />
        <Form.Input
          label='Longitude'
          onChange={handleInputChange}
          name='longitude'
          placeholder='Longitude'
          value={sitevodafone.longitude}
        />
        <Form.Field
          label='Remark'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='remark'
          placeholder='Remark'
          value={sitevodafone.remark}
        />
        <Button
          loading={submitting}
          floated='right'
          positive
          type='submit'
          content='Submit'
        />
        <Button
          onClick={() => history.push('/projectmanagement/sitevodafone')}
          floated='right'
          type='button'
          content='Cancel'
        />
      </Form>
    </Segment>
  );
};

export default observer(SiteVodafoneEditForm);
